import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export type MenuItem = {
  key: string;
  label: string;
  icon?: React.ReactNode;
};

type Props = {
  items: MenuItem[];
  activeKey?: string;
  onSelect: (key: string) => void;
};

export const Sidebar: React.FC<Props> = ({ items, activeKey, onSelect }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={`h-full border-r bg-card/50 transition-all duration-300 ease-in-out flex flex-col ${collapsed ? 'w-20' : 'w-64'}`}>
      <div className="flex h-14 items-center justify-between border-b px-4 overflow-hidden">
        <div className="flex items-center gap-2 min-w-0">
          {!collapsed ? (
            <>
              <img src="/logo.png" alt="logo" className="h-6 w-6 shrink-0" />
              <span className="text-sm font-semibold truncate transition-opacity duration-300 animate-in fade-in">
                VM Charm Admin
              </span>
            </>
          ) : (
            <span className="text-sm font-semibold truncate transition-opacity duration-300 animate-in fade-in">
              VM
            </span>
          )}
        </div>
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="rounded p-1 hover:bg-accent text-muted-foreground hover:text-foreground shrink-0"
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
        </button>
      </div>
      <div className={`p-3 text-xs font-semibold text-muted-foreground transition-all duration-300 ${collapsed ? 'opacity-0 py-0 h-0 overflow-hidden' : 'opacity-100'}`}>
        MENU
      </div>
      <nav className="flex flex-col">
        {items.map(it => {
          const active = activeKey === it.key;
          return (
            <button
              key={it.key}
              title={collapsed ? it.label : undefined}
              className={`group relative flex items-center px-4 py-2.5 text-left text-sm transition-colors hover:bg-accent ${active ? 'border-l-2 border-primary bg-accent/60 font-medium' : ''}`}
              onClick={() => onSelect(it.key)}
            >
              <span className={`shrink-0 transition-all duration-300 ${active ? 'text-foreground' : 'text-muted-foreground group-hover:text-foreground'} ${collapsed ? 'mx-auto' : 'mr-3'}`}>
                {it.icon}
              </span>
              <span className={`truncate transition-all duration-300 origin-left ${collapsed ? 'w-0 opacity-0 overflow-hidden' : 'w-auto opacity-100'}`}>
                {it.label}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;
